export default theme => ({
  notification: {
    // backgroundColor: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main)
  }
});
